import { VerifiedCustody } from "@verified-network/verified-custody";
import { useState } from "react";
import startupIcon from "../../assests/page/startup-coin-icon.svg";
import startupIconShadow from "../../assests/page/startup-icon-shadow.svg";
import { onMessage } from "firebase/messaging";
import { initFireBase } from "../../utils/helpers/firebase";
import {
  checkOTPVerification,
  sendCoSignerInvitation,
  sendCreatorAcceptance,
  sendCreatorAuthChanged,
  sendCreatorCompleted,
  sendCreatorConfirmation,
  sendCreatorInitiation,
  sendCreatorRejection,
  sendCreatorSigned,
  sendOTPVerification,
} from "../../utils/helpers/verifiedCustody.js";

const InAppWallet = (props) => {
  const [showCustody, setShowCustody] = useState(false);

  return (
    <div
      style={
        props.mobileScreen
          ? { maxWidth: "350px", maxHeight: "650px", padding: "0" }
          : { padding: "0", maxHeight: "650px", maxWidth: "400px" }
      }
      className="verify-kyc-popup"
    >
      {props.verifiedWalletDetails &&
        Object.values(props.verifiedWalletDetails).length === 0 &&
        !showCustody && (
          <div className="startup-outter">
            <div
              style={{
                border: "none",
                width: "100%",
                height: "100%",
                padding: "0",
              }}
              id="startup-div"
              className="startup"
            >
              <div className="startup-icon-container">
                <img
                  style={{ height: "100%", width: "100%" }}
                  className="startup-icon"
                  alt="Startup Icon"
                  src={startupIcon}
                />
                <img
                  className="startup-icon-shadow"
                  alt="Startup Icon Shadow"
                  src={startupIconShadow}
                />
              </div>
              <div className="startup-text-container">
                <p className="startup-text-header">
                  Secure your digital assets with Verified Wallet
                </p>
              </div>
              <button
                style={{ width: "90%" }}
                className="ftu-startup-button"
                onClick={async () => {
                  // Safari / unsupported browser check
                  const pushSupported =
                    "Notification" in window && "serviceWorker" in navigator;

                  if (!pushSupported) {
                    console.warn(
                      "Push notifications not supported on this browser.",
                    );
                    setShowCustody(true);
                    return;
                  }

                  try {
                    // Register service worker
                    await navigator.serviceWorker.register(
                      "/firebase-messaging-sw.js",
                    );

                    const { messaging } = initFireBase();

                    // Only request permission if not already granted
                    if (Notification.permission !== "granted") {
                      const permission = await Notification.requestPermission();
                      if (permission !== "granted") {
                        console.warn("Notification permission denied.");
                        return;
                      }
                      console.log("Notification permission granted.");
                    } else {
                      console.log("Notifications already granted.");
                    }

                    onMessage(messaging, (payload) => {
                      if (!("Notification" in window)) return;

                      if (payload.notification) {
                        new Notification(
                          payload.notification.title ?? "Notification",
                          {
                            body: payload.notification.body ?? "",
                          },
                        );
                      }
                    });

                    setShowCustody(true);
                  } catch (error) {
                    console.error("Error setting up notifications:", error);
                  }
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        )}

      {props.verifiedWalletDetails &&
        Object.values(props.verifiedWalletDetails).length > 0 &&
        !showCustody && (
          <VerifiedCustody
            action={props.action !== null ? props.action : undefined}
            origin={props.origin}
            title={props.title}
            chainId={props.chainId}
            reqVaultData={props.reqVaultData}
            txData={
              props.txData
                ? Object.keys(props.txData)?.map((ky) => {
                    props.txData[ky] = decodeURIComponent(props.txData[ky]);
                    return props.txData;
                  })[Object.keys(props.txData)?.length - 1]
                : null
            }
            helperFunctions={{
              sendCoSignerInvitation: sendCoSignerInvitation,
              sendCreatorConfirmation: sendCreatorConfirmation,
              sendCreatorInitiation: sendCreatorInitiation,
              sendCreatorSigned: sendCreatorSigned,
              sendCreatorCompleted: sendCreatorCompleted,
              sendCreatorAcceptance: sendCreatorAcceptance,
              sendCreatorRejection: sendCreatorRejection,
              sendOTPVerification: sendOTPVerification,
              checkOTPVerification: checkOTPVerification,
              sendCreatorAuthChanged: sendCreatorAuthChanged,
            }}
            txToSign={props.sigTx ? props.sigTx : null}
          />
        )}

      {props.verifiedWalletDetails && showCustody && (
        <VerifiedCustody
          action={props.action !== null ? props.action : undefined}
          origin={props.origin}
          title={props.title}
          chainId={props.chainId}
          reqVaultData={props.reqVaultData}
          txData={
            props.txData
              ? Object.keys(props.txData)?.map((ky) => {
                  props.txData[ky] = decodeURIComponent(props.txData[ky]);
                  return props.txData;
                })[Object.keys(props.txData)?.length - 1]
              : null
          }
          helperFunctions={{
            sendCoSignerInvitation: sendCoSignerInvitation,
            sendCreatorConfirmation: sendCreatorConfirmation,
            sendCreatorInitiation: sendCreatorInitiation,
            sendCreatorSigned: sendCreatorSigned,
            sendCreatorCompleted: sendCreatorCompleted,
            sendCreatorAcceptance: sendCreatorAcceptance,
            sendCreatorRejection: sendCreatorRejection,
            sendOTPVerification: sendOTPVerification,
            checkOTPVerification: checkOTPVerification,
            sendCreatorAuthChanged: sendCreatorAuthChanged,
          }}
          txToSign={props.sigTx ? props.sigTx : null}
        />
      )}

      {!props.verifiedWalletDetails && (
        <VerifiedCustody
          action={props.action !== null ? props.action : undefined}
          origin={props.origin}
          title={props.title}
          chainId={props.chainId}
          reqVaultData={props.reqVaultData}
          txData={
            props.txData
              ? Object.keys(props.txData)?.map((ky) => {
                  props.txData[ky] = decodeURIComponent(props.txData[ky]);
                  return props.txData;
                })[Object.keys(props.txData)?.length - 1]
              : null
          }
          helperFunctions={{
            sendCoSignerInvitation: sendCoSignerInvitation,
            sendCreatorConfirmation: sendCreatorConfirmation,
            sendCreatorInitiation: sendCreatorInitiation,
            sendCreatorSigned: sendCreatorSigned,
            sendCreatorCompleted: sendCreatorCompleted,
            sendCreatorAcceptance: sendCreatorAcceptance,
            sendCreatorRejection: sendCreatorRejection,
            sendOTPVerification: sendOTPVerification,
            checkOTPVerification: checkOTPVerification,
            sendCreatorAuthChanged: sendCreatorAuthChanged,
          }}
          txToSign={props.sigTx ? props.sigTx : null}
        />
      )}
    </div>
  );
};

export default InAppWallet;
